function isChrome() {
  return /Chrome/.test(navigator.userAgent)
}

function isEdge() {
  return /Edg/.test(navigator.userAgent)
}

function isSafari() {
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
}

export function isLegacyBrowser() {
  if (isEdge()) {
    const edgeVersion = navigator.userAgent.match(/Edg\/(\d+\.\d+\.\d+\.\d+)/)
    if (edgeVersion) {
      return parseInt(edgeVersion[1].split('.')[0]) <= 87
    }
  }

  if (isSafari()) {
    const safariVersion = navigator.userAgent.match(/Version\/(\d+\.\d+)/)
    if (safariVersion) {
      return parseInt(safariVersion[1].split('.')[0]) <= 13
    }
  }

  if (isChrome()) {
    const chromeVersion = navigator.userAgent.match(
      /Chrome\/(\d+\.\d+\.\d+\.\d+)/
    )
    if (chromeVersion) {
      return parseInt(chromeVersion[1].split('.')[0]) <= 87
    }
  }

  return false
}
